import { Controller } from "@hotwired/stimulus"

// Decorative canvas wave animation for the hero section.
// Four sine wave layers at different speeds / frequencies / vertical positions
// create a gentle water-like shimmer across the lower half of the hero.

export default class extends Controller {
  connect() {
    this.canvas = document.createElement("canvas")
    Object.assign(this.canvas.style, {
      position:      "absolute",
      inset:         "0",
      width:         "100%",
      height:        "100%",
      pointerEvents: "none",
      zIndex:        "0",
    })
    this.element.prepend(this.canvas)
    this.ctx = this.canvas.getContext("2d")

    // Each wave layer: amplitude (px), frequency, speed, initial phase, opacity, vertical centre
    this.waves = [
      { amp: 55, freq: 0.0055, speed: 0.18, phase: 0.0, opacity: 0.07, baseY: 0.45 },
      { amp: 32, freq: 0.0095, speed: 0.30, phase: 1.9, opacity: 0.05, baseY: 0.52 },
      { amp: 22, freq: 0.0145, speed: 0.47, phase: 3.4, opacity: 0.04, baseY: 0.38 },
      { amp: 72, freq: 0.0038, speed: 0.11, phase: 5.2, opacity: 0.03, baseY: 0.60 },
    ]

    this.time    = 0
    this.running = true

    this.boundTick   = this.tick.bind(this)
    this.boundResize = this.resize.bind(this)

    window.addEventListener("resize", this.boundResize)
    this.resize()
    requestAnimationFrame(this.boundTick)
  }

  disconnect() {
    this.running = false
    window.removeEventListener("resize", this.boundResize)
    this.canvas?.remove()
  }

  resize() {
    this.canvas.width  = this.element.offsetWidth
    this.canvas.height = this.element.offsetHeight
  }

  tick() {
    if (!this.running) return

    this.time += 0.007
    const { canvas, ctx, waves, time } = this
    const { width, height } = canvas

    ctx.clearRect(0, 0, width, height)

    waves.forEach(w => {
      const y0 = w.baseY * height

      // Trace the wave curve left → right, then close down to the canvas bottom
      ctx.beginPath()
      for (let x = 0; x <= width; x += 2) {
        const y = y0 + w.amp * Math.sin(w.freq * x + w.phase + time * w.speed)
        x === 0 ? ctx.moveTo(x, y) : ctx.lineTo(x, y)
      }
      ctx.lineTo(width, height)
      ctx.lineTo(0, height)
      ctx.closePath()

      // Gradient: brighter at the crest, fades to transparent toward the bottom
      const grad = ctx.createLinearGradient(0, y0 - w.amp, 0, height)
      grad.addColorStop(0,    `rgba(244,242,240,${w.opacity})`)
      grad.addColorStop(0.45, `rgba(244,242,240,${(w.opacity * 0.4).toFixed(3)})`)
      grad.addColorStop(1,    `rgba(244,242,240,0)`)
      ctx.fillStyle = grad
      ctx.fill()
    })

    requestAnimationFrame(this.boundTick)
  }
}
